const formFieldGradientIconStyles = () => ({
  root: {
    color: "inherit",
    "& .MuiSvgIcon-root": {
      fill: "url(#selected)",
    },
  },
});

export const gradientIconStyles = () => ({
  root: {
    color: "inherit",
    fill: "url(#selected)",
  },
});
export default formFieldGradientIconStyles;
